module.exports = __webpack_public_path__ + "js/0.e0b02c33.worker.js"